import type { ItemDefinition, ItemRegistryV1 } from "./types";
export const emptyRegistry = (): ItemRegistryV1 => ({
  version: 1,
  definitions: {},
  lots: {},
});
export function quantityOf(registry: ItemRegistryV1, key: string) {
  return (registry.lots[key] ?? []).reduce((n, l) => n + l.quantity, 0);
}
export function acquireItem(
  registry: ItemRegistryV1,
  definition: ItemDefinition,
  quantity: number,
  source: string,
  now = Date.now(),
) {
  const next = structuredClone(registry);
  next.definitions[definition.key] = definition;
  (next.lots[definition.key] ??= []).push({
    id: `L_${now}_${Math.random().toString(36).slice(2, 7)}`,
    quantity,
    acquiredAt: now,
    source,
  });
  return next;
}
export function consumeItem(
  registry: ItemRegistryV1,
  key: string,
  quantity: number,
) {
  if (quantityOf(registry, key) < quantity) throw new Error("素材数量不足");
  const next = structuredClone(registry);
  let left = quantity;
  for (const lot of next.lots[key] ?? []) {
    const used = Math.min(left, lot.quantity);
    lot.quantity -= used;
    left -= used;
    if (!left) break;
  }
  next.lots[key] = (next.lots[key] ?? []).filter((l) => l.quantity > 0);
  return next;
}
